import React from 'react'
import { BtnV2, l } from '@manychat/manyui'

import { useAppSelector } from 'reduxTyped'
import { getAnnualExpansionData } from 'apps/dashboard/helpers/annualExpansion/annualExpansionSelectors'
import { useAnnualExpansionRequestUpgrade } from 'apps/dashboard/helpers/annualExpansion/useAnnualExpansionRequestUpgrade'
import { UpgradeSource } from 'common/billing'

export const AnnualExpansion = () => {
  const pricingData = useAppSelector(getAnnualExpansionData)
  const requestUpgrade = useAnnualExpansionRequestUpgrade(
    UpgradeSource.ANNUAL_EXPANSION_NOTIFICATION,
    pricingData?.annualProductSlug,
  )

  return (
    <>
      <span>
        {l.translate(
          'You could be paying less by switching to annual billing. It will save you ${price}/yr.',
          { price: pricingData?.totalSaves },
        )}
      </span>
      <BtnV2 variant="success" onClick={requestUpgrade} className="m-l-sm">
        {l.translate('Switch to annual')}
      </BtnV2>
    </>
  )
}
